const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/stgag/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/stgag/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: undefined,
    },
    navbarTitle: undefined,
    welcomeTitle: undefined,
    welcomeText: undefined,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.stgag.ch',
        loginHelp: undefined,
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
        Beruf: 'Lookup/5028315e-4342-45ea-8ce5-3f890d5f3ba0/Children',
        Beziehung: 'Lookup/12cb2de9-e98d-4b61-91ac-a8c951890c61/Children',
        Geschlecht: 'Lookup/23bb8606-d55f-4990-baf3-9606ce33a533/Children',
        Zivilstand: 'Lookup/26ebc7c0-6d61-4583-bed3-5b8d1024905b/Children',
        Behandlungsgrund: 'Lookup/befa4543-a925-4595-b191-d1793a84c817/Children',
        Versicherung: 'Lookup/2a617c23-abaf-4013-b0fb-84ab2a0f3e4f/Children',
        Klasse: 'Lookup/fcef4cd5-1cb5-4435-9bb2-6ecef3efe26b/Children',
    },
    customMatomoClientId: 5,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
